import React from "react";
import { useParams } from "react-router-dom";

import { useQueryGetRubric } from "@examspark/common-app";
import { VSpace } from "@examspark/common-ui";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";
import Rubric from "../../components/unit/Rubric";

const RubricRoute = () => {
  const params = useParams<{
    id: string;
  }>();
  const { data } = useQueryGetRubric(params.id, "resource#v0");

  return (
    <VSpace style={{ gap: "3rem" }}>
      <PageHead>
        <Breadcrumbs items={Breadcrumbs.Browse()} />
        <PageTitle>{data?.name}</PageTitle>
      </PageHead>
      {data?.content && <Rubric data={data?.content?.rubric} />}
    </VSpace>
  );
};

export default RubricRoute;
